<template>
  <div class="index">
    <div class="index-con">
      <div class="big-title">
        <span>MAIQS 2026</span>
      </div>
      <div style="text-align: center;font-size: 18px;" class="small-title">Call for Papers</div>
      <!-- <div style="text-align: right;font-size: 18px;" class="small-title">
        —— MAIQS 2026
      </div> -->
      <!-- <iframe src="https://www.maiqs2026.org/index/public/file/callforpagers.jpg"
        style="height: 1000px" width="100%"></iframe> -->
      <img class="maiqs-img" src="https://www.maiqs2026.org/index/public/file/callforpagers.jpg" alt="">
      <div class="small-title">
        {{ $t("newsDetailText31") }}
        <a :href="pdfUrl" target="_blank" style="color: #0c70ae; cursor: pointer; text-decoration: underline;">
          {{ $t("newsDetailText32") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pdfUrl: "https://www.maiqs2026.org/index/public/file/poster.pdf",
    };
  },
  methods: {},
};
</script>

<style scoped>
.big-title {
  margin-bottom: 20px;
}

.title {
  color: #0a9a7a;
  font-size: 24px;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  margin-bottom: 70px;
  margin-top: 50px;
  position: relative;
}

.title::after {
  content: "";
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);
  width: 90px;
  height: 4px;
  text-align: center;
  background: #0a9a7a;
  position: absolute;
  margin-bottom: -10px;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
  padding-bottom: 170px;
}

.maiqs-img {
  width: 1000px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.text {
  color: #333;
  text-indent: 2em;
  line-height: 2;
  padding-bottom: 20px;
}

.w-350 {
  width: 350px;
  margin: 0 auto;
  text-indent: 0;
  text-align: center;
}

.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .nav {
    width: 100%;
  }

  .title {
    font-size: 18px;
  }

  .maiqs-img {
    width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/callforPapers.vue